<template>
  <div class="text-center">
    <v-dialog
        v-model="dialogConfitmation"
        v-on:close="toggleConfirmation({})"
        v-on:click:outside="toggleConfirmation({})"
        width="500"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Metode Pembayaran
        </v-card-title>

<!--        <v-card-text>-->
<!--          <table style="width: 100%; margin-top: 10px">-->
<!--            <tr>-->
<!--              <td>Tagihan</td>-->
<!--              <td>Rp. 25.000</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>Fee</td>-->
<!--              <td>Rp. 25</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>Admin Bank</td>-->
<!--              <td>Rp. 6.500</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>Total Bayar</td>-->
<!--              <td>Rp. 31.525</td>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </v-card-text>-->

        <v-list-item
            v-for="item in virtualAccount"
            :key="item.bank"
        >
          <v-list-item-avatar size="60">
            <v-img :src="item.avatar" height="50" max-width="50"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="item.virtualAccount"></v-list-item-title>

            <v-list-item-subtitle v-text="item.bank"></v-list-item-subtitle>
          </v-list-item-content>

<!--          <v-list-item-action>-->
<!--            <v-btn icon @click="doCopy(item.title)">-->
<!--              <v-icon color="grey lighten-1">mdi-clipboard-multiple-outline</v-icon>-->
<!--            </v-btn>-->
<!--          </v-list-item-action>-->

        </v-list-item>

        <v-card-text>
          <v-icon color="grey lighten-1">mdi-information-outline</v-icon>
          Tagiahan akan otomatis terupdate ketika pembayaran sudah diterima
        </v-card-text>

<!--        <v-card-actions>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn-->
<!--              color="primary"-->
<!--              text-->
<!--              @click="updateBill({id: activeId})"-->
<!--          >-->
<!--            Konfirmasi Pembayaran-->
<!--          </v-btn>-->
<!--        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Utils from "@/plugins/utils";
import moment from "moment";
// import VueClipboard from 'vue-clipboard2'
// import Vue from 'vue'

// VueClipboard.config.autoSetContainer = true // add this line

export default {
  name: "ModalUpdateConfirmation",
  data: ()=>({
  }),
  mounted() {

  },
  computed: {
    ...mapState('Bayartempo',['dialogConfitmation','activeId', "virtualAccount"])
  },
  methods: {
    ...mapActions('Bayartempo',['toggleConfirmation', 'toggleLoadingDialog']),
    formatAngka(val){
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
    },
    // doCopy: function (text) {
    //   this.$copyText(text).then(function (e) {
    //     console.log(text)
    //     alert(text)
    //     console.log(e)
    //   }, function (e) {
    //     alert('Can not copy')
    //     console.log(e)
    //   })
    // }
  }

}
</script>

<style scoped>

</style>